import * as React from 'react';
import { Button } from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';
import Map from '../map/Map';
import IWorkingAreaMap from '../workareas/IWorkingAreaMap';
import ICoordinate from '../map/ICoordinate';
import Polygon from '../map/shapes/Polygon';
import Circle from '../map/shapes/Circle';
import Marker from '../map/shapes/Marker';
import { getSiteName } from '../../shared/Site';
import * as Site from '../../shared/Site';


interface IPhotographerWorkAreasFormProps {
    photographerId: number;
    workingAreaMaps: Array<IWorkingAreaMap>;
    onMapChange: (maps: IWorkingAreaMap[]) => void;
    shouldUpdateMap: boolean;
    setDefaultConfigSe360: (currentWorkingAreaMap: IWorkingAreaMap) => void;
    setDefaultConfigScandphotos: (currentWorkingAreaMap: IWorkingAreaMap) => void;
    site: string;
}

export class PhotographerWorkAreasForm extends React.Component<
    IPhotographerWorkAreasFormProps,
    any
> {
    private workingAreaMaps: Array<IWorkingAreaMap> = null;
    private currentWorkingAreaMap: IWorkingAreaMap = null;
    private currentIndex: number = 0;

    private polygon: Polygon;
    private circle: Circle;
    private marker: Marker;

    constructor(props: any, context: any) {
        super(props, context);
        this.workingAreaMaps = this.props.workingAreaMaps;
        this.initMap();

        this.state = {
            currentWorkingAreaMap: this.currentWorkingAreaMap,
            currentIndex: this.currentIndex,
            polygon: this.polygon,
            circle: this.circle,
            marker: this.marker
        };

        this.usePolygon = this.usePolygon.bind(this);
        this.useCircle = this.useCircle.bind(this);
        this.onCircleChange = this.onCircleChange.bind(this);
        this.onPolygonChange = this.onPolygonChange.bind(this);
        this.onMarkerChange = this.onMarkerChange.bind(this);
    }

    initMap() {
        if (!this.workingAreaMaps || this.workingAreaMaps.length === 0) {
            let defaultBase: ICoordinate = {
                latitude: 59.329323,
                longitude: 18.068581
            };
            let defaultPath: ICoordinate[] = this.getDefaultPolygon(defaultBase);

            // Initialize seven maps with Stockholm as
            // configuration
            this.workingAreaMaps = [];
            for (let i = 0; i < 7; i++) {
                this.workingAreaMaps.push({
                    id: null,
                    day: i + 1,
                    usePolygon: false,
                    useCircle: false,
                    base: defaultBase,
                    polygon: defaultPath,
                    circleCenter: defaultBase,
                    circleRadius: 3000
                });
            }
        }

        this.currentWorkingAreaMap = this.workingAreaMaps[this.currentIndex];
        if (this.currentWorkingAreaMap) {
            let polygonPath =
                this.currentWorkingAreaMap.usePolygon && this.currentWorkingAreaMap.polygon
                    ? this.currentWorkingAreaMap.polygon
                    : this.getDefaultPolygon(this.currentWorkingAreaMap.base);
            this.polygon = new Polygon(
                polygonPath,
                false,
                true,
                this.currentWorkingAreaMap.usePolygon,
                this.onPolygonChange
            );

            let circleCenter =
                this.currentWorkingAreaMap.useCircle && this.currentWorkingAreaMap.circleCenter
                    ? this.currentWorkingAreaMap.circleCenter
                    : this.currentWorkingAreaMap.base;
            let circleRadius =
                this.currentWorkingAreaMap.useCircle && this.currentWorkingAreaMap.circleRadius
                    ? this.currentWorkingAreaMap.circleRadius
                    : 3000;

            this.circle = new Circle(
                circleCenter,
                circleRadius,
                false,
                true,
                this.currentWorkingAreaMap.useCircle,
                this.onCircleChange
            );

            this.marker = new Marker(
                this.currentWorkingAreaMap.base,
                true,
                true,
                this.onMarkerChange
            );
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps: IPhotographerWorkAreasFormProps, nextState: any) {
        this.workingAreaMaps = nextProps.workingAreaMaps;
        this.initMap();

        if (!nextProps.workingAreaMaps || nextProps.workingAreaMaps.length === 0) {
            this.props.onMapChange(this.workingAreaMaps);
        }
    }

    shouldComponentUpdate(nextProps: IPhotographerWorkAreasFormProps, nextState: any) {
        return nextProps.shouldUpdateMap;
    }

    onPolygonChange(path: ICoordinate[]) {
        this.currentWorkingAreaMap.polygon = path;
        this.workingAreaMaps[this.currentIndex] = this.currentWorkingAreaMap;
        this.props.onMapChange(this.workingAreaMaps);
    }

    onCircleChange(center: ICoordinate, radius: number) {
        this.currentWorkingAreaMap.circleCenter = center;
        this.currentWorkingAreaMap.circleRadius = Math.round(radius);
        this.workingAreaMaps[this.currentIndex] = this.currentWorkingAreaMap;
        this.props.onMapChange(this.workingAreaMaps);
    }

    onMarkerChange(center: ICoordinate) {
        this.currentWorkingAreaMap.base = center;
        this.workingAreaMaps[this.currentIndex] = this.currentWorkingAreaMap;
        this.props.onMapChange(this.workingAreaMaps);
    }

    changeDay(day: number) {
        this.currentIndex = day;
        this.initMap();
        this.updateState();
        this.workingAreaMaps[this.currentIndex] = this.currentWorkingAreaMap;
        this.props.onMapChange(this.workingAreaMaps);
    }

    usePolygon() {
        if (!this.currentWorkingAreaMap.usePolygon) {
            this.currentWorkingAreaMap.useCircle = false;
            this.circle.setVisible(false);

            this.currentWorkingAreaMap.polygon = this.getDefaultPolygon(
                this.currentWorkingAreaMap.base
            );
            this.currentWorkingAreaMap.usePolygon = true;
            this.polygon.setVisible(true);

            this.workingAreaMaps[this.currentIndex] = this.currentWorkingAreaMap;
            this.props.onMapChange(this.workingAreaMaps);
        } else {
            this.currentWorkingAreaMap.usePolygon = false;
            this.polygon.setVisible(false);
            this.props.onMapChange(this.workingAreaMaps);
        }
    }

    useCircle() {
        if (!this.currentWorkingAreaMap.useCircle) {
            this.currentWorkingAreaMap.usePolygon = false;
            this.polygon.setVisible(false);

            this.currentWorkingAreaMap.useCircle = true;
            this.currentWorkingAreaMap.circleCenter = this.currentWorkingAreaMap.base;

            this.circle.setVisible(true);

            this.workingAreaMaps[this.currentIndex] = this.currentWorkingAreaMap;
            this.props.onMapChange(this.workingAreaMaps);
        } else {
            this.currentWorkingAreaMap.useCircle = false;
            this.circle.setVisible(false);
            this.props.onMapChange(this.workingAreaMaps);
        }
    }

    render() {
        return (
            <div>
                <Button
                    name="monday"
                    role="button"
                    bsStyle={this.state.currentIndex === 0 ? 'primary' : 'default'}
                    onClick={() => this.changeDay(0)}
                >
                    {Translate('photographers/modal/form/workareas/button-label/monday')}
                </Button>

                <Button
                    name="tuesday"
                    role="button"
                    bsStyle={this.state.currentIndex === 1 ? 'primary' : 'default'}
                    onClick={() => this.changeDay(1)}
                >
                    {Translate('photographers/modal/form/workareas/button-label/tuesday')}
                </Button>

                <Button
                    name="wednesday"
                    role="button"
                    bsStyle={this.state.currentIndex === 2 ? 'primary' : 'default'}
                    onClick={() => this.changeDay(2)}
                >
                    {Translate('photographers/modal/form/workareas/button-label/wednesday')}
                </Button>

                <Button
                    name="thursday"
                    role="button"
                    bsStyle={this.state.currentIndex === 3 ? 'primary' : 'default'}
                    onClick={() => this.changeDay(3)}
                >
                    {Translate('photographers/modal/form/workareas/button-label/thursday')}
                </Button>

                <Button
                    name="friday"
                    role="button"
                    bsStyle={this.state.currentIndex === 4 ? 'primary' : 'default'}
                    onClick={() => this.changeDay(4)}
                >
                    {Translate('photographers/modal/form/workareas/button-label/friday')}
                </Button>

                <Button
                    name="saturday"
                    role="button"
                    bsStyle={this.state.currentIndex === 5 ? 'primary' : 'default'}
                    onClick={() => this.changeDay(5)}
                >
                    {Translate('photographers/modal/form/workareas/button-label/saturday')}
                </Button>

                <Button
                    name="sunday"
                    role="button"
                    bsStyle={this.state.currentIndex === 6 ? 'primary' : 'default'}
                    onClick={() => this.changeDay(6)}
                >
                    {Translate('photographers/modal/form/workareas/button-label/sunday')}
                </Button>

                <Map
                    settings={[
                        {
                            polygon: this.polygon as Polygon,
                            circle: this.circle as Circle,
                            center: this.marker.Center as ICoordinate,
                            marker: this.marker as Marker,
                            entityId: this.props.photographerId
                        }
                    ]}
                    center={this.marker.Center}
                />

                <Button
                    name="usepolygon"
                    role="button"
                    bsStyle={this.currentWorkingAreaMap.usePolygon ? 'primary' : 'default'}
                    onClick={this.usePolygon}
                >
                    {Translate('photographer/modal/form/workareas/button/use-polygon')}
                </Button>
                <Button
                    name="usecircle"
                    role="button"
                    bsStyle={this.currentWorkingAreaMap.useCircle ? 'primary' : 'default'}
                    onClick={this.useCircle}
                >
                    {Translate('photographer/modal/form/workareas/button/use-circle')}
                </Button>
                <Button
                    name="copytootherdays"
                    role="button"
                    bsStyle={'primary'}
                    onClick={() => {
                        this.props.setDefaultConfigSe360(this.currentWorkingAreaMap);
                    }}
                >
                    {Translate('photographer/modal/form/workareas/button/copy-to-other-days/se360')}
                </Button>
                {this.props.site !== getSiteName(Site.Zentuvo) ? <Button
                    name="copytootherdays"
                    role="button"
                    bsStyle={'primary'}
                    onClick={() => {
                        this.props.setDefaultConfigScandphotos(this.currentWorkingAreaMap);
                    }}
                >
                    {Translate(
                        'photographer/modal/form/workareas/button/copy-to-other-days/scandphotos'
                    )}
                </Button> : null}
            </div>
        );
    }

    /**
     * Returns a polygon in the shape of a square based on given
     * base coordinate.
     */
    getDefaultPolygon(base: ICoordinate): ICoordinate[] {
        return [
            { latitude: base.latitude - 0.05, longitude: base.longitude - 0.1 },
            { latitude: base.latitude + 0.05, longitude: base.longitude - 0.1 },
            { latitude: base.latitude + 0.05, longitude: base.longitude + 0.1 },
            { latitude: base.latitude - 0.05, longitude: base.longitude + 0.1 },
            { latitude: base.latitude - 0.05, longitude: base.longitude - 0.1 }
        ];
    }

    updateState() {
        this.setState((prevState: any, props: IPhotographerWorkAreasFormProps) => {
            return {
                currentWorkingAreaMap: this.currentWorkingAreaMap,
                currentIndex: this.currentIndex,
                polygon: this.polygon,
                circle: this.circle,
                marker: this.marker
            };
        });
    }
}

export default PhotographerWorkAreasForm;
